<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="apiMonitor/blacklists">
      <div slot="toolbar">
        <el-button type="success" @click="refreshCache()">刷新缓存</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="封禁IP">
            <el-input v-model.trim="filter.ip" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="封禁原因">
            <el-input v-model.trim="filter.reason" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="封禁状态">
            <el-select v-model.trim="filter.status" clearable placeholder="请选择">
              <el-option label="生效中" :value="0"/>
              <el-option label="已过期" :value="1"/>
              <el-option label="手动解封" :value="2"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <!--      <el-table-column type="selection" align="center" width="55" :selectable="isRowSelectable"/>-->
      <el-table-column
          label="操作"
          align="center"
          width="80"
          fixed="left">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status === 0" type="success" @click="unblockIp(scope.row)">
            解封
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="封禁IP" width="180">
        <template slot-scope="scope">
          <el-link type="danger" @click="optionIp(scope.row,1)">封禁</el-link>
          <el-link type="success" @click="optionIp(scope.row,0)">解封</el-link>
          <span style="margin-left: 5px;">{{scope.row.ip}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="封禁原因" width="140"/>
      <el-table-column prop="triggerRule" label="触发规则"/>
      <el-table-column prop="blockType" label="封禁方式" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.blockType === 0">自动</span>
          <span v-if="scope.row.blockType === 1">人工</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="封禁状态" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">生效中</span>
          <span v-if="scope.row.status === 1">已过期</span>
          <span v-if="scope.row.status === 2">手动解封</span>
        </template>
      </el-table-column>
      <el-table-column prop="blockedBy" label="封禁操作人" width="100"/>
      <el-table-column prop="blockedAt" label="封禁时间"/>
      <el-table-column prop="expireAt" label="过期时间"/>
      <el-table-column prop="unblockedAt" label="解封时间"/>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";

  export default {
    name: "BlackList",
    components: {VmTable, VmSearch},
    data() {
      return {
        constant,
        authName: auth.getUserName(),
        currentUserId: auth.getUserId(),
        selections: [],
        filter: {
          ip: "",
          reason: "",
          triggerRule: "",
          status: "",
        },
      };
    },

    mounted() {
      this.getList(1);
    },

    methods: {
      refreshCache() {
        this.$http.post("basic", "apiMonitor/blacklist/refreshCache").then(() => {
          this.$message.success("刷新成功.");
        });
      },
      optionIp(row, status) {
        if (status === 1) {//封禁IP
          this.$confirm("确定封禁当前IP吗?", "提示", {type: "warning"}).then(() => {
            let params = {
              blockIp: row.ip,
              reason: "web端手动封禁",
            };
            this.$http.post("basic", "apiMonitor/blacklist/block", "", params).then(() => {
              this.getList(1);
              this.$message.success("封禁成功");
            });
          });
        } else {//解封
          this.$confirm("确定解封当前IP吗?", "提示", {type: "warning"}).then(() => {
            let params = {
              blockIp: row.ip,
            };
            this.$http.post("basic", "apiMonitor/blacklist/unblockByIp", params, params).then(() => {
              this.getList(1);
              this.$message.success("解封成功");
            });
          });
        }
      },
      unblockIp(row) {
        this.$confirm("确定解封当前IP吗?", "提示", {type: "warning"}).then(() => {
          let params = {
            blockId: row.pkid,
          };
          this.$http.post("basic", "apiMonitor/blacklist/unblock", params, params).then(() => {
            this.getList(1);
            this.$message.success("解封成功");
          });
        });
      },
      getList(pageNo) {
        this.$refs.vmTable.getList(pageNo);
      },

    },
  };
</script>